import { PACE_OPTIONS as sharedPaces, DURATION_OPTIONS as sharedDurations, type PlayingPace } from '@league/shared/schemas';

/** Authenticated-app descriptions. Stored pace values are unchanged. */
export const PACE_OPTIONS = sharedPaces.map(option => ({
  ...option,
  label: option.value === 'brisk' ? 'Quick' : option.label,
  description: { relaxed: 'I like a little more thinking time.', steady: 'I keep the game moving comfortably.', brisk: 'I enjoy a faster-moving game.', unknown: '' }[option.value],
}));
export const DURATION_OPTIONS = sharedDurations.map(option => ({ ...option, label: option.value === 'first_session' ? 'First session only' : 'Throughout this league' }));
export function paceLabel(pace: PlayingPace | null | undefined): string {
  return PACE_OPTIONS.find(option => option.value === pace)?.label ?? 'Not sure yet';
}
